export default __webpack_public_path__ + "static/media/icon_check_mark.3aac87e5.png";